var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", { attrs: { errors: _vm.stockGetErrors } }),
      _c("base-snackbar", {
        attrs: { errors: _vm.feedingProgramCategoryPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.feedingProgramCategoryPostErrors = $event
          }
        }
      }),
      _c(
        "v-toolbar",
        {
          attrs: {
            color: !_vm.$objectEmpty(_vm.defaultFieldValues)
              ? "yellow darken-3"
              : "primary",
            elevation: "0",
            dense: "",
            dark: ""
          }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$objectEmpty(_vm.defaultFieldValues) ? "New" : "Edit")
            )
          ])
        ]
      ),
      _c("feeding-program-category-form", {
        attrs: {
          "column-attributes": _vm.columnAttributes,
          "input-fields": _vm.inputFields,
          "default-field-values": _vm.defaultFieldValues,
          "stock-categories": _vm.stockCategoryList,
          errors: _vm.$objectChangeKeyCase(_vm.feedingProgramCategoryPostErrors)
        },
        on: {
          "update:inputFields": function($event) {
            _vm.inputFields = $event
          },
          "update:input-fields": function($event) {
            _vm.inputFields = $event
          }
        }
      }),
      _c(
        "v-btn",
        {
          staticClass: "mr-2",
          attrs: {
            color: "primary",
            dark: "",
            dense: "",
            loading: _vm.feedingProgramCategoryPosting
          },
          on: { click: _vm.sendRequestFeedingProgramCategory }
        },
        [_c("span", [_vm._v("Save")])]
      ),
      !_vm.$objectEmpty(_vm.defaultFieldValues)
        ? _c(
            "v-btn",
            {
              attrs: { color: "error", dark: "", dense: "" },
              on: { click: _vm.cancelEdit }
            },
            [_c("span", [_vm._v("Cancel")])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }